export const GA_TAG_ID = window.env.googleAnalyticsTagId;

export const Gtag = window.gtag;
